import { render } from "./MainHeaderTwo.vue?vue&type=template&id=204e5286"
import script from "./MainHeaderTwo.vue?vue&type=script&lang=js"
export * from "./MainHeaderTwo.vue?vue&type=script&lang=js"

import "./MainHeaderTwo.vue?vue&type=style&index=0&id=204e5286&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__